import actions from "@/store/modules/file/actions";
import mutations from "@/store/modules/file/mutations";
import state from "@/store/modules/file/state";

export default {
    actions,
    mutations,
    state
}